<script>
import DoMoreInStoreCardComponent from './DoMoreInStoreCardComponent.vue';

export default {
  name: 'DoMoreInStoreComponent',
  components: {
    DoMoreInStoreCardComponent,
  },
  props: {
    storePagesDoMoreInStoreModel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      doMoreInStoreTitle: 'Do more in store',
    };
  },
  mounted() {
    if (window.location.hash === '#do-more-in-store') {
      this.$nextTick(() => {
        const targetElement = document.querySelector('#do-more-in-store');

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      });
    }
  },
};
</script>

<template>
  <section
    v-if="storePagesDoMoreInStoreModel.enabled"
    class="do-more-in-store"
    data-ui="do-more-in-store"
  >
    <h2
      id="do-more-in-store"
      class="do-more-in-store__title"
      data-ui="do-more-in-store-title"
    >
      {{ doMoreInStoreTitle }}
    </h2>
    <do-more-in-store-card-component
      v-for="(service, index) in storePagesDoMoreInStoreModel.doMoreInStoreCards"
      :key="`do-more-in-store-${index}`"
      :index-card="index"
      :do-more-in-store-card="service"
    />
  </section>
</template>
